const version = "8.10.1";

export { version as v };
